// Modified AppLayout.jsx - Keep only session timeout functionality
import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import sessionTimeoutManager from '../utils/sessionTimeoutManager';
import SessionTimeoutWarning from './SessionTimeoutWarning';

const SessionTimeoutWrapper = ({ children }) => {
  const timeoutWarningRef = useRef(null);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  // Initialize session timeout when component mounts and user is logged in
  useEffect(() => {
    if (currentUser) {
      console.log('Initializing session timeout for user:', currentUser.email);
      
      // Initialize the session timeout manager
      sessionTimeoutManager.init({
        timeoutDuration: 60 * 60 * 1000, // 2 minutes
        warningTime: 5 * 60 * 1000, // 1 minute warning
        onWarning: () => {
          console.log('Warning timeout triggered - showing modal');
          if (timeoutWarningRef.current) {
            timeoutWarningRef.current.showModal();
          }
        },
        onTimeout: async () => {
          console.log('Session timeout triggered - logging out');
          if (timeoutWarningRef.current) {
            timeoutWarningRef.current.hideModal();
          }
          
          try {
            await sessionTimeoutManager.defaultTimeout();
            navigate('/login', { 
              state: { 
                from: window.location.pathname,
                message: 'Your session has expired due to inactivity. Please log in again.'
              } 
            });
          } catch (error) {
            console.error('Error during session timeout:', error);
          }
        }
      });
      
      return () => {
        sessionTimeoutManager.clearTimeouts();
      };
    }
  }, [currentUser, navigate]);

  return (
    <>
      {children}
      <SessionTimeoutWarning ref={timeoutWarningRef} />
    </>
  );
};

export default SessionTimeoutWrapper;